export const STANDARD_DATE_FORMAT = `MM/DD/YYYY`;
export const USER_DATE_FORMAT = 'MMM DD, YYYY';
export const METRICS_DATE_FORMAT = 'YYYY-MM-DD';
